/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const notificheAPI = {
  lista: async () => { const { data } = await apiClient.get('/notifiche'); return data; },
  segnaLetta: async (id) => { const { data } = await apiClient.patch(`/notifiche/${id}/letta`); return data; },
  leggiTutte: async () => { const { data } = await apiClient.patch('/notifiche/leggi-tutte'); return data; },
};
